import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService } from '../api.service';
import { Classification, SelectItem } from '@models';

@Injectable()
export class ClassificationService extends ApiService<Classification> {

    protected apiGroup: string = 'crm';
	protected apiName: string = 'classification';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	selectItemArray(): SelectItem[] {
		let array: SelectItem[] = [];

		for(var item of this.items) {
			array.push({
				label: item.classification,
				value: item.id
			})
		}

		return array;
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/crm/classification.service.ts